import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
  GridToolbarColumnsButton,
  GridToolbarExportContainer,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Themtuyenxedien from "components/Danhmuc/Tuyenxedien/Themtuyenxedien.js";
import Capnhattuyenxedien from "components/Danhmuc/Tuyenxedien/Capnhattuyenxedien.js";
import Danhmucxetuyendienexcel from "components/Xuatexcel/Danhmuc/Danhmucxetuyendienexcel.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const tuyencolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "matuyen",
    headerName: "Mã tuyến",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "tentuyen",
    headerName: "Tên tuyến",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "diemdau",
    headerName: "Điểm đầu",
    width: 210,
    headerAlign: "center",
  },
  {
    field: "diemcuoi",
    headerName: "Điểm cuối",
    width: 210,
    headerAlign: "center",
  },
  {
    field: "culy",
    headerName: "Cự ly",
    width: 130,
    headerAlign: "center",
  },
  {
    field: "lotrinh",
    headerName: "Lộ trình",
    width: 490,
    headerAlign: "center",
  },
  {
    field: "tinhtrang",
    headerName: "Tình trạng",
    width: 170,
    headerAlign: "center",
  },
];

export default function Danhmuctuyenxedien() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [tuyen, setTuyen] = React.useState([]);
  const [tuyen_id, setTuyen_id] = React.useState(0);
  const [alert, setAlert] = React.useState(false);
  const [disableBT, setDisableBT] = React.useState(true);
  const [openthem, setOpenthem] = React.useState(false);
  const [opensua, setOpensua] = React.useState(false);
  const handleClose = () => {
    setOpenthem(false);
    gettuyen();
  };
  const handleClosesua = () => {
    setOpensua(false);
    gettuyen();
  };
  const openthemtuyen = () => {
    setOpenthem(true);
    setDisableBT(true); // fix delete button
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
        <GridToolbarColumnsButton />
        <GridToolbarExportContainer>
          <Danhmucxetuyendienexcel />
        </GridToolbarExportContainer>
      </Box>
    );
  };
  const gettuyen = () => {
    var url = Config.backend + "/api/Tuyen/gettuyenxedien?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTuyen(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoatuyen = () => {
    var url = Config.backend + "/api/Tuyen/xoatuyenxedien";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: tuyen_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
          gettuyen();
          setDisableBT(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  React.useEffect(() => {
    gettuyen();
  }, []);

  return (
    <GridContainer>
      <GridItem
        xs={12}
        sm={10}
        md={12}
        style={{ marginTop: 5, marginBottom: 10 }}
      >
        <FormControl style={{ width: "12%" }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 32 }}
            onClick={openthemtuyen}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="error"
            variant="contained"
            style={{ height: 32 }}
            disabled={disableBT}
            onClick={xoatuyen}
          >
            Xóa
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={tuyen}
            columns={tuyencolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              setTuyen_id(params.row.id);
              setDisableBT(false);
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setOpensua(true);
                setDisableBT(true); // fix delete button
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm tuyến xe điện
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themtuyenxedien />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opensua}
          onClose={handleClosesua}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật tuyến xe điện
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosesua} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhattuyenxedien tuyen_id={Number(tuyen_id)} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
